import * as Joi from 'joi';

export const carBrandCreateUpdateSchema = Joi.object({
  name: Joi.string().required().max(255),
  country: Joi.string().required().max(255),
});
